import { render, staticRenderFns } from "./details-header.vue?vue&type=template&id=432a075b&scoped=true"
import script from "./details-header.vue?vue&type=script&lang=js"
export * from "./details-header.vue?vue&type=script&lang=js"
import style0 from "./details-header.vue?vue&type=style&index=0&id=432a075b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432a075b",
  null
  
)

export default component.exports